import React from 'react';
import AdminLayout from '../../layout/AdminLayout';
import AdminItemList from './AdminItemList';

const AdminItemIndexPage = () => {
  return (
    <AdminLayout>
      <AdminItemList />
    </AdminLayout>
  );
};

export default AdminItemIndexPage;
